import { message } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { convertServiceProviderListToDropdown } from "../../Helpers/ServiceProviderHelpers";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { apiCallback } from "../../ApiHandlers/Common";
import ListDeviceMangement from "../DeviceSkuManagement/ListDeviceMangement";

class ListDevices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      providerdata: [],
      providerDataLoading: false,
      selectedProvider: null,
      selectedProoviderName: null,
      action: null,
      record: null,
    };
  }
  componentDidMount() {
    this.updateProviderList();
  }

  updateProviderList = () => {
    const { history, serviceProviderApi } = this.props;
    this.setState({ providerDataLoading: true });

    const errorCallback = (error) => {
      this.setState({ providerDataLoading: false });
      message.error("Error Fetching Provider List");
    };

    const successCallback = (data) => {
      const providerData = convertServiceProviderListToDropdown(data);
      this.setState({ providerData, providerDataLoading: false });
    };
    try {
      serviceProviderApi.getServiceprovider(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  onProviderSelect = (id, value) => {
    this.setState({
      selectedProvider: id,
      selectedProviderName: value.children,
    });
  };
  onActionClick = (action, record) => (e) => {
    this.setState({ action, record });
  };
  render() {
    const { deviceModelRecord, onParentActionClick, parentBread } = this.props;
    const {
      providerData,
      providerDataLoading,
      selectedProvider,
      selectedProviderName,
    } = this.state;
    return (
      <div>
        <ListDeviceMangement
          deviceModelRecord={deviceModelRecord}
          providerData={providerData}
          providerDataLoading={providerDataLoading}
          selectedProvider={selectedProvider}
          onProviderSelect={this.onProviderSelect}
          onActionClick={this.onActionClick}
          selectedProviderName={selectedProviderName}
          onParentActionClick={onParentActionClick}
          parentBread={parentBread}
        />
      </div>
    );
  }
}
ListDevices.propTypes = {
  serviceProviderApi: PropTypes.object,
  providerData: PropTypes.array,
  providerDataLoading: PropTypes.bool,
  selectedProvider: PropTypes.string,
  onProviderSelect: PropTypes.func,
  onActionClick: PropTypes.func,
  deviceModelRecord: PropTypes.object,
  parentBread: PropTypes.array,
};
const mapStateToProps = (state) => ({
  serviceProviderApi: state.apis.serviceProviderApi,
});
const connectedAssetManagement = connect(mapStateToProps)(ListDevices);
export default withRouter(connectedAssetManagement);
